import React from 'react';
import VerifiedBadge from './VerifiedBadge';

const AboutUs = () => {
  return (
    <section className="f4k-page about-us-page">
      <div className="f4k-panel about-us-panel">
        <p className="about-us-kicker">About Friendly for Kids</p>
        <h1 className="f4k-title">Exploring with children should feel simple, not stressful.</h1>

        <p className="about-us-lead">
          Travelling and going out with children shouldn't feel like a logistical challenge.
        </p>

        <p>
          Friendly for Kids helps parents quickly find places, indoors and outdoors, that genuinely welcome families,
          wherever they are.
        </p>

        <p>
          Friendly for Kids is a location-based discovery platform built specifically for parents. It allows families to
          find child-friendly restaurants, parks, hiking trails, accommodations, hotels, and activities in one place.
          Parents can filter results based on what actually matters to them, from high chairs, changing tables, and kids'
          menus to play corners, family rooms, and child-friendly facilities.
        </p>

        <div className="about-us-trust-block">
          <p className="about-us-trust-intro">
            What sets Friendly for Kids apart is trust. Selected places can be verified.
          </p>
          <div className="about-us-trust-badge-row">
            <VerifiedBadge size={34} variant={1} />
            <span className="about-us-trust-badge-label">Verified listing</span>
          </div>
          <p>
            Giving parents confidence that the information they rely on is accurate. Combined with clear listings and
            smart filters, this makes planning everyday outings or family trips faster, easier, and far less stressful.
          </p>
        </div>

        <p>
          We aim to reduce stress, save time, and support families in exploring the world with confidence. Our goal is
          simple: to make exploring the world with children easier and much more enjoyable.
        </p>
      </div>
    </section>
  );
};

export default AboutUs;